import React from "react";
import get from "lodash/get";
import find from "lodash/find";
import uniq from "lodash/uniq";
import { connect } from "react-redux";
import {
  Alert,
  Icon,
  Layout,
  Table,
  Button,
  Modal,
  Badge,
  Tooltip,
  Switch,
  Select,
  Input,
  message,
  Checkbox,
} from "antd";
import moment from "moment";


import Footer from "../../components/Footer/Footer";
import classes from "./FinanceInvoicesEditor.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  activateFinanceInvoiceRequest,
  deleteFinanceInvoiceRequest,
  getFinanceInvoiceSearchRequest,
  sentFinanceInvoiceRequest,
  draftFinanceInvoiceRequest,
  paidFinanceInvoiceRequest,
  cancelFinanceInvoiceRequest,
  getCustomersLight,
  getSettingsSitesRequest,
  downloadFinanceInvoiceRequest,
  financeExchange, getFinanceEventsList,
  invoiceRemoveEventsRequest,
  getFinanceInvoiceSitesRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getFinanceInvoiceCreatePermission,
  getFinanceInvoiceDeletePermission,
  getFinanceInvoiceUpdatePermission,
} from "../../reducers/user/selectors";
import FinanceInvoiceForm from "../../components/FinanceInvoiceForm/FinanceInvoiceForm";
import { withNamespaces } from "react-i18next";

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;

const colors = {
  created: "blue",
  sent: "gold",
  paid: "green",
  cancelled: "gray",
  overdue: "red",
};

class FinanceInvoicesEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      invoices: [],
      sites: [],
      users: [],
      filter: "",
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      site: null,
      customer_id: null,
      event_id: null,
      status: null,
      order: null,
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      sortedInfo: {},
      invoiceEdit: null,
      approvedSelected: null,
      confirmAction: null,
      checkedItems: [],
      shiftDown: false,
      isFilterApprove: false,
      totalAmount: null,
      currencies: { USD: 1, EUR: 1, AUD: 1, CAD: 1 },
      eventList: [],
    };
  }

  statusText() {
    return {
      created: this.props.i18n.t('NamespaceFinanceInvoicesEditor:Draft'),
      sent: this.props.i18n.t('NamespaceFinanceInvoicesEditor:Sent'),
      paid: this.props.i18n.t('NamespaceFinanceInvoicesEditor:Paid'),
      cancelled: this.props.i18n.t('NamespaceFinanceInvoicesEditor:Cancelled'),
      overdue: this.props.i18n.t('NamespaceFinanceInvoicesEditor:Overdue'),
    };
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: true,
      });
    }
  };

  handleKeyUp = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: false,
      });
    }
  };

  async componentDidMount() {
    this.onNameSearch();
    this.getCurrencies();
    this.getFinanceEventList();

    try {
      const [{ data: users }, { data: sites }] = await Promise.all([
        getCustomersLight(),
        getFinanceInvoiceSitesRequest(),
      ]);

      this.setState({ sites, users });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
    }

    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keyup", this.handleKeyUp);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  getFinanceEventList = async () => {
    const { data } = await getFinanceEventsList();
    this.setState({
      eventList: data,
    });
  };

  getCurrencies = async () => {
    const result = await Promise.all([
      financeExchange({ fromCurrency: "USD", toCurrency: "CAD" }),
      financeExchange({ fromCurrency: "EUR", toCurrency: "CAD" }),
      financeExchange({ fromCurrency: "AUD", toCurrency: "CAD" }),
    ]);

    this.setState({
      currencies: {
        'USD': result[0].data.exchange_rate,
        'EUR': result[1].data.exchange_rate,
        'AUD': result[2].data.exchange_rate,
        'CAD': 1,
      }
    })
  };

  onNameSearch = async (value) => {
    this.setState({ nameSearch: value, eventsSelected: {}, currentPage: 1 }, this.getInvoices);
  };

  getInvoices = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getFinanceInvoiceSearchRequest({
        search: this.state.nameSearch,
        order_direction: this.state.order,
        page,
        per_page,
        order_column: get(this.state, "sortedInfo.columnKey"),
        filter_by: this.state.filter,
        site_code: this.state.site,
        event_id: this.state.event_id,
        customer_id: this.state.customer_id,
        invoice_status: this.state.status,
      });

      console.log(get(this.state, "sortedInfo.columnKey"));

      if (Array.isArray(data.data)) {
        this.setState({
          invoices: data.data,
          total: data.total_pages * per_page,
          currentPage: page,
        });
      } else {
        this.setState({
          invoices: data,
          total: 1 * per_page,
          currentPage: page,
        });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        invoices: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getInvoices(pagination.current, pagination.pageSize)
    );
  };

  onInvoiceEdit = (item) => () => {
    this.setState({ invoiceEdit: item });
  };

  onInvoiceEditHide = () => {
    this.setState({ invoiceEdit: null });
  };

  onInvoiceEditSubmit = () => {
    this.setState({ invoiceEdit: null }, this.getInvoices);
  };

  addInvoice = () => {
    this.setState({ invoiceEdit: {} });
  };

  clearFilters = () => {
    this.setState(
      { nameSearch: null, filter: null, status: null, currentPage: 1 },
      this.getInvoices
    );
  };

  onSwitchInvoiceActivation = (id, state) => async () => {
    try {
      if (state === "active") {
        await deleteFinanceInvoiceRequest(id);
      } else {
        await activateFinanceInvoiceRequest(id);
      }

      message.success(this.props.i18n.t('Saved'));

      this.getInvoices();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
      console.log(e);
    }
  };

  onConfirmActionHide = () => {
    this.setState({
      confirmAction: null,
    });
  };

  onSent = (invoiceId) => async () => {
    try {
      await sentFinanceInvoiceRequest({ invoiceId });

      message.success(this.props.i18n.t('Saved'));
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    } finally {
      this.getInvoices();
    }
  };

  onCancelled = (invoiceId) => async () => {
    try {
      await cancelFinanceInvoiceRequest({ invoiceId });

      message.success(this.props.i18n.t('Saved'));

    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    } finally {
      this.getInvoices();
    }
  };

  onDraft = (invoiceId) => async () => {
    try {
      await draftFinanceInvoiceRequest({ invoiceId });

      message.success(this.props.i18n.t('Saved'));

    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    } finally {
      this.getInvoices();
    }
  };

  onRemoveMilestones = (invoiceId) => async () => {
    try {
      await invoiceRemoveEventsRequest({ invoiceId });

      message.success("Saved");
    } catch (e) {
      message.error("Something went wrong");
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    } finally {
      this.getInvoices();
    }
  };

  downloadInvoice = (invoiceId) => async () => {
    try {
      const response = await downloadFinanceInvoiceRequest({ invoiceId });
      const data = response.data;
      if (!(data instanceof Blob)) return;

      const blob = new Blob([data], { type: "application/pdf" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `invoice-${invoiceId}.pdf`;
      document.body.appendChild(link);
      // Start download
      link.click();
      document.body.removeChild(link);
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      if (e.response.status === 404) {
        message.error(e.response.data.error);
        return;
      }

      message.error("Error");
      console.log(e);
    }
  };

  onPaid = (invoiceId) => async () => {
    try {
      await paidFinanceInvoiceRequest({ invoiceId });

      message.success(this.props.i18n.t('Saved'));

    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    } finally {
      this.getInvoices();
    }
  };

  handleFilterChange = (value) => {
    this.setState(
      {
        filter: value,
        site: null,
        event_id: null,
        customer_id: null,
        status: null,
        eventsSelected: {},
        sortedInfo: null,
        currentPage: 1
      },
      this.getInvoices
    );
  };
  handleSiteChange = (value) => {
    this.setState({ site: value, sortedInfo: null, currentPage: 1 }, this.getInvoices);
  };
  handleCustomerChange = (value) => {
    this.setState({ customer_id: value, sortedInfo: null, currentPage: 1 }, this.getInvoices);
  };
  handleMilestoneChange = (value) => {
    this.setState({ event_id: value, sortedInfo: null, currentPage: 1 }, this.getInvoices);
  };
  handleStatusChange = (value) => {
    this.setState(
      { status: value, sortedInfo: null, site: null, currentPage: 1 },
      this.getInvoices
    );
  };

  calculateTotalAmount = async () => {
    this.setState({
      totalAmount: null,
    });

    if (this.state.checkedItems.length > 0) {
      const totalAmount = this.state.checkedItems.reduce((acc, item) => {
        return (
          acc + item.invoice_subtotal * this.state.currencies[item.currency]
        );
      }, 0);

      this.setState({ totalAmount });
    }
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      sites,
      users,
      invoices,
      currentPage,
      total,
      pageSize,
      invoiceEdit,
      confirmAction,
      nameSearch,
      filter,
      site,
      customer_id,
      sortedInfo,
      checkedItems,
      shiftDown,
      totalAmount,
      event_id,
      eventList
    } = this.state;
    const { financeInvoiceCreatePermission } = this.props;

    const selectedBulkStatus = get(this.state.checkedItems[0], "id");

    const columns = [
      {
        dataIndex: "checkbox",
        key: "checkbox",
        title: () =>
          invoices && invoices.length > 0 &&
          !this.state.isFilterApprove && (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  this.setState(
                    ({ checkedItems }) => ({
                      checkedItems: uniq([
                        checkedItems[0] || invoices[0],
                        ...invoices.reduce(
                          (result, item) => [...result, item],
                          []
                        ),
                      ]),
                    }),
                    this.calculateTotalAmount
                  );
                } else {
                  this.setState(
                    ({ checkedItems }) => ({
                      checkedItems: [],
                    }),
                    this.calculateTotalAmount
                  );
                }
              }}
              indeterminate={
                checkedItems.length > 0 &&
                checkedItems.length !== invoices.length
              }
              checked={checkedItems.length === invoices.length}
            />
          ),
        render: (val, generatedEventItem, index) => (
          <div>
            {!this.state.isFilterApprove && (
              <Checkbox
                onChange={(e) => {
                  if (checkedItems.length && shiftDown) {
                    const lastCheckedItemIndex = invoices.findIndex(
                      (item) =>
                        item.id === checkedItems[checkedItems.length - 1].id
                    );

                    let newItems = [];

                    if (lastCheckedItemIndex < index) {
                      newItems = invoices.reduce((result, item, itemIndex) => {
                        return itemIndex > lastCheckedItemIndex &&
                        itemIndex <= index
                          ? [...result, item]
                          : result;
                      }, []);
                    } else {
                      newItems = invoices.reduce((result, item, itemIndex) => {
                        return itemIndex < lastCheckedItemIndex &&
                        itemIndex >= index
                          ? [...result, item]
                          : result;
                      }, []);
                    }

                    this.setState(
                      ({ checkedItems }) => ({
                        checkedItems: uniq([...checkedItems, ...newItems]),
                      }),
                      this.calculateTotalAmount
                    );
                  } else {
                    this.setState(
                      ({ checkedItems }) => ({
                        checkedItems: e.target.checked
                          ? uniq([...checkedItems, generatedEventItem])
                          : uniq(
                            checkedItems.filter(
                              (item) => item.id !== generatedEventItem.id
                            )
                          ),
                      }),
                      this.calculateTotalAmount
                    );
                  }
                }}
                checked={
                  checkedItems.findIndex(
                    (item) => item.id === generatedEventItem.id
                  ) > -1
                }
              />
            )}
          </div>
        ),
      },
      {
        dataIndex: "title",
        key: "title",
        title: this.props.i18n.t('Title'),
        render: (val, record) => (
          <div className={classes.nameWrapper}>
            <div style={{ width: "86px" }}>
              <Badge
                count={record.state}
                style={{
                  backgroundColor:
                    record.state === "active" ? "#52c41a" : "#777",
                }}
              />
              <br />
            </div>
            {val}
          </div>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "title" && sortedInfo.order,
      },
      {
        dataIndex: "customer_id",
        key: "customer_id",
        title: this.props.i18n.t('Customer'),
        render: (val) =>
          get(
            find(users, ({ id }) => id === val),
            "name"
          ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "customer_id" && sortedInfo.order,
      },
      {
        dataIndex: "site_id",
        key: "site_id",
        title: this.props.i18n.t('Site'),
        render: (val) =>
          get(
            find(sites, ({ id }) => id === val),
            "name"
          ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "site_id" && sortedInfo.order,
      },
      {
        dataIndex: "invoice_number",
        key: "invoice_number",
        title: this.props.i18n.t('NamespaceFinanceInvoicesEditor:Invoice number'),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "invoice_number" && sortedInfo.order,
      },
      {
        dataIndex: "po_so_number",
        key: "po_so_number",
        title: this.props.i18n.t('NamespaceFinanceInvoicesEditor:PO/SO'),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "po_so_number" && sortedInfo.order,
      },
      {
        dataIndex: "invoice_total_with_taxes_formatted",
        key: "invoice_total_with_taxes_formatted",
        title: this.props.i18n.t('NamespaceFinanceInvoicesEditor:Total amount'),
        sorter: false,
        // sortOrder:
        //   get(sortedInfo, "columnKey") === "invoice_subtotal_formatted" &&
        //   sortedInfo.order,
      },
      {
        dataIndex: "currency",
        key: "currency",
        title: this.props.i18n.t('Currency'),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "currency" && sortedInfo.order,
      },
      {
        dataIndex: "invoice_date",
        key: "invoice_date",
        title: this.props.i18n.t('NamespaceFinanceInvoicesEditor:Invoice date'),
        render: (val) => moment(val).format("YYYY-MM-DD HH:mm"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "invoice_date" &&
          sortedInfo.order,
      },
      {
        dataIndex: "status",
        key: "status",
        title: this.props.i18n.t('Status'),
        render: (val, record) => (
          <div className={classes.nameWrapper}>
            <div style={{ width: "86px" }}>
              <Badge
                count={this.statusText()[val]}
                style={{
                  backgroundColor: colors[val],
                }}
              />
            </div>
          </div>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "status" && sortedInfo.order,
      },
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t('Actions'),
        render: (val, item) => (
          <div className={classes.actions}>
            {item.status === "created" && (
              <Tooltip placement="topLeft" title={this.props.i18n.t('NamespaceFinanceInvoicesEditor:Edit Invoice')}>
                <Icon
                  type="edit"
                  theme="filled"
                  className={classes.iconEdit}
                  onClick={this.onInvoiceEdit(item)}
                />
              </Tooltip>
            )}
            &nbsp; &nbsp;
            <div style={{ width: "90px", display: "flex" }}>
              {((this.props.financeInvoiceUpdatePermission &&
                item.state === "inactive") ||
                (this.props.financeInvoiceDeletePermission &&
                  item.state === "active")) && (
                <div>
                  <b className={classes.switchLabel}>{this.props.i18n.t('State')}</b>
                  <br />
                  <Tooltip
                    placement="topLeft"
                    title={this.props.i18n.t('NamespaceFinanceInvoicesEditor:Activate / Deactivate Invoice')}
                  >
                    <Switch
                      className={classes.reactivateBtn}
                      checked={item.state === "active"}
                      onChange={() => {
                        this.setState({
                          confirmAction: {
                            id: val,
                            title:
                              item.state === "active"
                                ? "Deactivate invoice"
                                : "Activate invoice",
                            action: this.onSwitchInvoiceActivation(
                              val,
                              item.state
                            ),
                          },
                        });
                      }}
                    />
                  </Tooltip>
                </div>
              )}
            </div>
            &nbsp; &nbsp;
            <div className={classes.buttonWrapper}>
              {item.status === "created" && (
                <Button
                  type="primary"
                  size="small"
                  onClick={() =>
                    this.setState({
                      confirmAction: {
                        id: val,
                        title: this.props.i18n.t('NamespaceFinanceInvoicesEditor:Sent'),
                        action: this.onSent(val),
                      },
                    })
                  }
                >
                  {this.props.i18n.t('NamespaceFinanceInvoicesEditor:Sent')}
                </Button>
              )}
              &nbsp;
              {item.status !== "cancelled" && (
                <Button
                  type="primary"
                  size="small"
                  onClick={() =>
                    this.setState({
                      confirmAction: {
                        id: val,
                        title: this.props.i18n.t('NamespaceFinanceInvoicesEditor:Cancel'),
                        action: this.onCancelled(val),
                      },
                    })
                  }
                >
                  {this.props.i18n.t('NamespaceFinanceInvoicesEditor:Cancel')}
                </Button>
              )}
              {item.status === "sent" && (
                <div>
                  <Button
                    type="primary"
                    size="small"
                    onClick={() =>
                      this.setState({
                        confirmAction: {
                          id: val,
                          title: this.props.i18n.t('NamespaceFinanceInvoicesEditor:Paid'),
                          action: this.onPaid(val),
                        },
                      })
                    }
                  >
                    {this.props.i18n.t('NamespaceFinanceInvoicesEditor:Paid')}
                  </Button>
                  &nbsp;
                  <Button
                    type="primary"
                    size="small"
                    onClick={() =>
                      this.setState({
                        confirmAction: {
                          id: val,
                          title: this.props.i18n.t('NamespaceFinanceInvoicesEditor:Draft'),
                          action: this.onDraft(val),
                        },
                      })
                    }
                  >
                    {this.props.i18n.t('NamespaceFinanceInvoicesEditor:Draft')}
                  </Button>
                </div>
              )}

              {item.status === "created" && (
                <div>
                  <Button
                    type="primary"
                    size="small"
                    onClick={() =>
                      this.setState({
                        confirmAction: {
                          id: val,
                          title: this.props.i18n.t("NamespaceFinanceInvoicesEditor:Remove Milestones"),
                          text:
                            this.props.i18n.t("NamespaceFinanceInvoicesEditor:Are you sure you want to remove the milestones attached to this invoice? Milestones will return to Generated Events with status 'Invoice cancelled'"),
                          action: this.onRemoveMilestones(val),
                        },
                      })
                    }
                  >
                    Remove Milestones
                  </Button>
                </div>
              )}

              {item.status === "cancelled" && (
                <div style={{ marginLeft: '15px' }}>
                  <Button
                    type="primary"
                    size="small"
                    onClick={() =>
                      this.setState({
                        confirmAction: {
                          id: val,
                          title: this.props.i18n.t('NamespaceFinanceInvoicesEditor:Draft'),
                          action: this.onDraft(val),
                        },
                      })
                    }
                  >
                    {this.props.i18n.t('NamespaceFinanceInvoicesEditor:Draft')}
                  </Button>
                </div>
              )}
              &nbsp;
              {item.status !== "cancelled" && (
                <Button
                  type="primary"
                  size="small"
                  onClick={() =>
                    this.setState({
                      confirmAction: {
                        id: val,
                        title: this.props.i18n.t('Download'),
                        action: this.downloadInvoice(val),
                      },
                    })
                  }
                >
                  {this.props.i18n.t('Download')}
                </Button>
              )}
            </div>
          </div>
        ),
      },
    ];

    return (
      <div>
        <Layout className={classes.parentContainer}>

          <Content className={classes.content}>
            <h3 className="headline-default">{this.props.i18n.t('NamespaceFinanceInvoicesEditor:Invoices')}</h3>

            <div className={classes.searchWrapper}>
              <label className={classes.searchWrapperSearch}>
                <b className={classes.searchWrapperLabel}>{this.props.i18n.t('SEARCH')}</b>
                <Search
                  placeholder={this.props.i18n.t('NamespaceFinanceInvoicesEditor:By name, invoice number or PO')}
                  enterButton={this.props.i18n.t('Search')}
                  size="large"
                  onSearch={this.onNameSearch}
                  value={nameSearch}
                  onChange={this.onNameChange}
                  style={{ maxWidth: "500px" }}
                />
              </label>

              <div className={classes.searchWrapperFilter}>
                <label className={classes.searchWrapperFilterItem}>
                  <b className={classes.searchWrapperLabel}>{this.props.i18n.t('Filter by')}</b>
                  <Select
                    onChange={this.handleFilterChange}
                    value={filter}
                    style={{ width: "100%" }}
                    placeholder={this.props.i18n.t('Select')}
                  >
                    <Option value="site">{this.props.i18n.t('NamespaceFinanceInvoicesEditor:Site')}</Option>
                    <Option value="status">{this.props.i18n.t('NamespaceFinanceInvoicesEditor:Status')}</Option>
                    <Option value="customer">{this.props.i18n.t('NamespaceFinanceInvoicesEditor:Customer')}</Option>
                    <Option value="Event">{this.props.i18n.t('NamespaceFinanceInvoicesEditor:Event')}</Option>
                  </Select>
                </label>

                {filter === "site" && (
                  <label className={classes.searchWrapperFilterItem}>
                    <b className={classes.searchWrapperLabel}>{this.props.i18n.t('Site')}</b>
                    <Select
                      onChange={this.handleSiteChange}
                      value={site}
                      style={{ width: "100%" }}
                      placeholder={this.props.i18n.t('Select')}
                      showSearch
                      optionFilterProp="children"
                      filterOption
                    >
                      {sites
                        .filter((site) => site.site_type === "randomization")
                        .sort(
                          (a, b) =>
                            +`${a.code}`.split("-")[0] - +`${b.code}`.split("-")[0]
                        )
                        .map((site) => (
                          <Option key={site.code} value={site.code}>
                            {site.code} - {site.name}
                          </Option>
                        ))}
                      <Option value="">{this.props.i18n.t('All sites')}</Option>
                    </Select>
                  </label>
                )}

                {filter === "customer" && (
                  <label className={classes.searchWrapperFilterItem}>
                    <b className={classes.searchWrapperLabel}>{this.props.i18n.t('NamespaceFinanceInvoicesEditor:Customer')}</b>
                    <Select
                      onChange={this.handleCustomerChange}
                      value={customer_id}
                      style={{ width: "100%" }}
                      placeholder={this.props.i18n.t('Select')}
                      showSearch
                      optionFilterProp="children"
                      filterOption
                    >
                      {users.map((user) => (
                        <Option key={user.id} value={user.id}>
                          {user.name}
                        </Option>
                      ))}
                      <Option value="">{this.props.i18n.t('NamespaceFinanceInvoicesEditor:All customers')}</Option>
                    </Select>
                  </label>
                )}

                {filter === "Event" && (
                  <label className={classes.searchWrapperFilterItem}>
                    <b className={classes.searchWrapperLabel}>{this.props.i18n.t('Event')}</b>
                    <Select
                      onChange={this.handleMilestoneChange}
                      value={event_id}
                      style={{ width: "100%" }}
                      placeholder={this.props.i18n.t('Select')}
                      showSearch
                      optionFilterProp="children"
                      filterOption
                    >
                      {eventList.map(({ id, name }) => (
                        <Option value={id} key={id}>
                          {name}
                        </Option>
                      ))}
                    </Select>
                  </label>
                )}

                {filter === "status" && (
                  <label className={classes.searchWrapperFilterItem}>
                    <b className={classes.searchWrapperLabel}>{this.props.i18n.t('Status')}</b>
                    <Select
                      onChange={this.handleStatusChange}
                      value={this.state.status}
                      style={{ width: "100%" }}
                      placeholder={this.props.i18n.t('Select')}
                    >
                      {Object.keys(this.statusText()).map((status) => (
                        <Option key={status} value={status}>
                          {this.statusText()[status]}
                        </Option>
                      ))}
                      <Option value="">{this.props.i18n.t('NamespaceFinanceInvoicesEditor:All statuses')}</Option>
                    </Select>
                  </label>
                )}
              </div>

              <span className={classes.clearButton} onClick={this.clearFilters}>
                {this.props.i18n.t('Clear')}
              </span>
            </div>

            {errorMessage && (
              <Alert
                type="error"
                message={errorMessage}
                className={classes.alert}
              />
            )}

            {responseMessage && (
              <Alert
                type="success"
                message={responseMessage}
                className={classes.alert}
              />
            )}

            {financeInvoiceCreatePermission && (
              <div>
                <Button type="primary" onClick={this.addInvoice}>
                  {this.props.i18n.t('NamespaceFinanceInvoicesEditor:Add new invoice')}
                </Button>
                <br />
                <br />
              </div>
            )}

            <Table
              columns={columns}
              dataSource={invoices}
              loading={isLoading}
              rowKey="id"
              onChange={this.handleTableChange}
              pagination={{
                onShowSizeChange: (current, size) => {
                  this.setState({ pageSize: size });
                },
                current: currentPage,
                total,
                pageSize,
                showSizeChanger: true,
                pageSizeOptions: ["10", "25", "50", "100"],
                position: 'both',
              }}
            />

            <div className={classes.actionWrapper}>
              {selectedBulkStatus && (
                <div
                  style={{
                    position: "fixed",
                    padding: "1rem 3rem",
                    borderTop: "1px solid #eee",
                    boxShadow: "0 25px 50px 12px rgba(0,0,0,.25)",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    zIndex: 99,
                    background: "rgba(255,255,255,0.95)",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <p style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                      <span style={{ color: "#999" }}>
                        {this.state.checkedItems.length} {this.props.i18n.t('selected')}
                      </span>
                    </p>
                    <button
                      style={{
                        outline: "none",
                        cursor: "pointer",
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        border: "none",
                        color: "#aaa",
                      }}
                      onClick={() => this.setState({ checkedItems: [] })}
                    >
                      <Icon type="close" />
                    </button>
                  </div>
                  <div style={{ display: "flex" }}>
                    Total amount:{" "}
                    {totalAmount &&
                    totalAmount
                      .toFixed(2)
                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                    CAD
                  </div>
                </div>
              )}
            </div>

            {/*{isLoading && <Icon type="loading" />}*/}

            <Modal
              visible={!!invoiceEdit}
              onCancel={this.onInvoiceEditHide}
              footer={null}
              width="760px"
            >
              {invoiceEdit && (
                <FinanceInvoiceForm
                  {...invoiceEdit}
                  isNew={invoiceEdit && !invoiceEdit.id}
                  onSubmit={this.onInvoiceEditSubmit}
                  onCancel={this.onInvoiceEditHide}
                  sites={sites}
                  users={users}
                />
              )}
            </Modal>

            <Modal
              visible={!!confirmAction}
              onCancel={this.onConfirmActionHide}
              footer={null}
            >
              {confirmAction && (
                <div>
                  <h4 className="headline-default">{this.props.i18n.t('Confirm action')}</h4>
                  {confirmAction.text ? (
                    <p>{confirmAction.text}</p>
                  ) : (
                    <p>{this.props.i18n.t("NamespaceFinanceInvoicesEditor:Are you sure you want to")} "{confirmAction.title}"?</p>
                  )}
                  <Button
                    type="primary"
                    onClick={async () => {
                      await confirmAction.action();
                      this.setState({ confirmAction: null });
                    }}
                  >
                    {this.props.i18n.t('Yes')}
                  </Button>
                  &nbsp;
                  <Button onClick={this.onConfirmActionHide}>{this.props.i18n.t('No')}</Button>
                </div>
              )}
            </Modal>
          </Content>

        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  financeInvoiceCreatePermission: getFinanceInvoiceCreatePermission(state),
  financeInvoiceDeletePermission: getFinanceInvoiceDeletePermission(state),
  financeInvoiceUpdatePermission: getFinanceInvoiceUpdatePermission(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(FinanceInvoicesEditor))
);



// WEBPACK FOOTER //
// ./src/containers/FinanceInvoicesEditor/FinanceInvoicesEditor.js